import { Toast, useToast } from "@oysterhr/ui"
import { ReactNode } from "react"
import { useTranslation } from "react-i18next"

export type DisplayErrorToastArgs = ContentArgs | ErrorListArgs

type ContentArgs = {
  content: ReactNode
  errors?: undefined
} & TitleArg

type ErrorListArgs = {
  errors: string[]
  content?: undefined
} & TitleArg

type TitleArg = {
  title?: string | null
}

export function useErrorToast() {
  const toast = useToast()
  const [t] = useTranslation("DefaultToastContents")

  return ({ content, errors, title = t("error.title") }: DisplayErrorToastArgs) => {
    const renderedContent = content || renderErrorList(errors)
    toast({
      render: (
        <Toast isCloseable variation="error">
          {title && <Toast.Title>{title}</Toast.Title>}
          <Toast.Content>{renderedContent}</Toast.Content>
        </Toast>
      ),
    })
  }
}

function renderErrorList(errors?: string[]) {
  if (!errors) return null

  if (errors.length === 1) return errors[0]

  return (
    <ul>
      {errors.map((error, index) => (
        <li key={index}>{error}</li>
      ))}
    </ul>
  )
}
